import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

class StructureService {
  static async convertToSmiles(structure) {
    return MessageBroker.send(RequestUrls.convertMolToSmiles, { structure });
  }
}
export default StructureService;
